import { render, staticRenderFns } from "./DetailUsulan.vue?vue&type=template&id=37855015&lang=pug&"
import script from "./DetailUsulan.vue?vue&type=script&lang=js&"
export * from "./DetailUsulan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports